import React from 'react';
import {Box} from '@mui/material';
import {NAVY, PISTE_PROGRESSION, VERT_PROGRESSION} from '../../tokens.js';

const ENCART = {
    position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000, maxWidth: 420,
    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', p: '28px 32px', backgroundColor: '#FFFFFF',
    border: '1px solid #D5DAE1', borderRadius: '16px', boxShadow: '0 1px 2px rgba(16,46,105,.06), 0 1px 3px rgba(16,46,105,.05)', textAlign: 'center',
};

/** R9 : encart « Chargement des PAV… » + barre de progression (Carte-Chargement.dc.html). */
export function EncartChargement() {
    return (
        <Box role="status" aria-live="polite" sx={{...ENCART, minWidth: 280}}>
            <Box component="span" sx={{fontWeight: 700}}>Chargement des PAV…</Box>
            <Box sx={{width: 220, height: 6, backgroundColor: PISTE_PROGRESSION, borderRadius: '999px', overflow: 'hidden'}}>
                <Box sx={{
                    width: '45%', height: '100%', backgroundColor: VERT_PROGRESSION, borderRadius: '999px',
                    '@keyframes carteProgression': {'0%': {transform: 'translateX(-100%)'}, '100%': {transform: 'translateX(230%)'}},
                    animation: 'carteProgression 1.4s ease-in-out infinite',
                    '@media (prefers-reduced-motion: reduce)': {animation: 'none', transform: 'translateX(40%)'},
                }}/>
            </Box>
        </Box>
    );
}

/** R9 : sélection vide (Carte-Vide.dc.html). `resume` = rappel des filtres actifs. */
export function EncartVide({resume, onReinitialiser, onElargir}) {
    return (
        <Box role="status" sx={ENCART}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#5F5F5F" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M12 22s7-7.2 7-12.5A7 7 0 0 0 5 9.5C5 14.8 12 22 12 22z"/><path d="m9.5 7 5 5M14.5 7l-5 5"/>
            </svg>
            <Box component="span" sx={{fontSize: 16, fontWeight: 700}}>Aucun PAV dans cette sélection</Box>
            <Box component="span" sx={{fontSize: 13, color: '#6B7480'}}>
                {resume ? `${resume} — ` : ''}aucun point ne cumule ces critères sur la période.
            </Box>
            <Box sx={{display: 'flex', gap: '10px', mt: '6px', flexWrap: 'wrap', justifyContent: 'center'}}>
                <Box component="button" type="button" onClick={onReinitialiser} sx={{height: 36, px: '14px', border: `1px solid ${NAVY}`, backgroundColor: NAVY, color: '#FFFFFF', borderRadius: '999px', font: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer'}}>
                    Réinitialiser les filtres
                </Box>
                <Box component="button" type="button" onClick={onElargir} sx={{height: 36, px: '14px', border: '1px solid #D5DAE1', backgroundColor: '#FFFFFF', color: '#2D333B', borderRadius: '999px', font: 'inherit', fontSize: 13, fontWeight: 600, cursor: 'pointer'}}>
                    Élargir la période
                </Box>
            </Box>
        </Box>
    );
}
